import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import * as popupActions from './../../../actions/A_Popups';
import template from './../../../templates/PageLayout/Popups/ErrorBox.rt';

class ErrorBox extends PureComponent {
  render() {
    return template.apply(this);
  }
}

function mapStateToProps(state) {
  const {errorBox} = state.popups;
  return {
    errorBox
  }
}

function mapDispatchToProps(dispatch) {
  return {
    buttonClick: text => dispatch(popupActions.errorBox_ButtonClick(text))
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ErrorBox);


